import { useSearchParams } from "next/navigation";

export const useMapSectionQuery = () => {
  const searchParams = useSearchParams();
  const keys = Array.from(searchParams.keys());
  const query = Array.from(new Set(keys)).reduce(
    (query, key) => {
      query[key] =
        keys.filter((x) => x === key).length > 1
          ? searchParams.getAll(key)
          : searchParams.get(key);

      return query;
    },
    {} as Record<string, any>,
  );

  return query;
};
